import { SaleFormInput } from '@src/core/buyerApiClient';
import { formInputGroupKey } from '@src/domains/orders/core/form-inputs/formInputGroupKey';

export interface TariffUnitGroup {
  /** Identity of the row: the tariff, not the unit. */
  tariffId: string;
  name: string;
  /** One set of inputs per unit bought of that tariff. */
  units: Array<SaleFormInput[]>;
}

/**
 * `organizeFormInputs` returns one group per unit (tariff + number), so two units of
 * the same tariff arrive as two entries. The list shows one row per tariff with the
 * quantity instead; telling the units apart is the modal's job.
 */
export const groupTariffUnits = (formInputGroups: Array<SaleFormInput[]>): TariffUnitGroup[] => {
  const byTariff = new Map<string, TariffUnitGroup>();

  formInputGroups.forEach((inputs) => {
    const first = inputs[0];

    if (!first) {
      return;
    }

    const tariffId = first.saleTariff?.id ?? formInputGroupKey(inputs);
    const group = byTariff.get(tariffId) ?? { tariffId, name: first.saleTariff?.name ?? '', units: [] };

    group.units.push(inputs);
    byTariff.set(tariffId, group);
  });

  return Array.from(byTariff.values());
};
